module.exports = __webpack_public_path__ + "img/Image-2.f855faf4.png";